import { ProductFilterSettingsModel } from '../models/product/productFilterSettingsModel';
import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ProductModel } from '../models/product/productModel';
import { ProductRelationFilterModel } from '../models/product/productRelationFilterModel';

class ProductService {
    authService = new AuthService();
    axiosInstance = axios.create({
        baseURL: `${Constants.apiUrl}/`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    })

    getAllProducts(from: number, numberOfRows: number, settings: ProductFilterSettingsModel) {
        return this.axiosInstance({
            url: `products/getAll/${from}/${numberOfRows}`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(settings)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getProduct(id: number) {
        return this.axiosInstance({
            url: `products/getById/${id}`,
            method: 'get'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addProduct(product: ProductModel) {
        return this.axiosInstance({
            url: `products/create`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(product)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    editProduct(user: ProductModel) {
        return this.axiosInstance({
            url: `products/update`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(user)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deactivateProduct(id: number) {
        return this.axiosInstance({
            url: `products/deactivate/${id}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getFilteredProducts(filter: ProductRelationFilterModel) {
        return this.axiosInstance({
            url: `productsMobile/getFilteredProducts`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(filter)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

}

export default ProductService;
